import classNames from "classnames";
import React, { useMemo } from "react";
import { INavigationLink } from "../../../../models";
import { IAxiosError } from "../../../../utils";
import { ErrorLoadingDataHoc } from "../../error/ErrorLoadingDataHoc";
import { AvisPageTitle } from "./AvisPageTitle";
import { AvisFormNavigation } from "./navigationBlock/AvisFormNavigation";

export interface IAvisFormProps {
  className?: string;
  title?: string;
  pageTitle?: string;
  hidePageTitle?: boolean;
  backLink?: INavigationLink;
  forwardLink?: INavigationLink;
  children?: React.ReactNode;
  actions?: React.ReactNode;
  error?: IAxiosError;
  loading?: boolean;
}

export function AvisForm(props: Readonly<IAvisFormProps>) {
  const {
    children,
    actions,
    title,
    pageTitle,
    hidePageTitle,
    className,
    error,
    loading,
    backLink,
    forwardLink,
  } = props;

  const formClassName = classNames(className, "avis-form");
  const renderActions = useMemo(() => {
    if (!actions) return;

    return <div className="avis-form-actions">{actions}</div>;
  }, [actions]);

  const renderContent = useMemo(() => {
    if (!children) return;

    return <div className="avis-form-content">{children}</div>;
  }, [children]);

  const renderTitle = useMemo(() => {
    if (!title) return;

    return <h1 className="avis-form-title">{title}</h1>;
  }, [title]);

  return (
    <div className={formClassName}>
      {!hidePageTitle && <AvisPageTitle title={title ?? pageTitle} />}
      <AvisFormNavigation backLink={backLink} forwardLink={forwardLink} />
      {renderTitle}
      <ErrorLoadingDataHoc error={error} loading={loading}>
        {renderContent}
        {renderActions}
      </ErrorLoadingDataHoc>
    </div>
  );
}
